import React from 'react';
import withBaseComponent from "components/Base"
import withStyles from "@material-ui/core/styles/withStyles";
import ProfileStyle from "assets/jss/components/SideProfile"
import {
  createFragmentContainer,
  graphql,
} from 'react-relay';
import {getPath, disableLink, maxStrDisplay} from "local-util"
import Language from "@material-ui/icons/Language";
import CompanyAdd from "@material-ui/icons/PlaylistAdd"
import classNames from "classnames";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Build from "@material-ui/icons/Build";
import Photo from "@material-ui/icons/PersonOutline";
import { Manager, Target, Popper } from "react-popper";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Paper from "@material-ui/core/Paper";

const Profile = withStyles(ProfileStyle)(
  class Profile extends React.Component {
    constructor(props) {
      super(props)
      this.state = {
        selector: false,
        activeCompanyId: window.localStorage.getItem('activeCompanyId')
      }

    }
    activeCompany(profile) {
      const activeCompanyId = this.state.activeCompanyId

      if (activeCompanyId) {
        return profile.employment.find((e) => {
          return activeCompanyId == e.companyId
        })
      } else {
        return profile.employment[0]
      }
    }
    render() {
      const {classes, profile, router, fileUrl, parentClasses} = this.props

      const Picture = <span/>

      if (this.props.profile.isSuperadmin) {
        return (
          <div >
            <List className={parentClasses.list}>
              <a style={{color: "inherit"}} onClick={disableLink} href="/admin/companies">

                <ListItem className={parentClasses.item}>
                  <ListItemIcon className={parentClasses.itemIcon}>
                    <Language/>
                  </ListItemIcon>
                  <ListItemText
                    onClick={() => {
                      this.props.router.push("/admin/companies")
                    }}
                    disableTypography={true}
                    primary={"All Companies"}
                    className={parentClasses.itemText + " " + classes.selectedItem}>
                  </ListItemText>
                </ListItem>
              </a>
              <a style={{color: "inherit"}} onClick={disableLink} href="/admin/create">
                <ListItem className={parentClasses.item}>
                  <ListItemIcon className={parentClasses.itemIcon}>
                    <CompanyAdd/>
                  </ListItemIcon>
                  <ListItemText
                    onClick={() => {
                      this.props.router.push("/admin/create")
                    }}
                    disableTypography={true}
                    primary={"Add Company"}
                    className={parentClasses.itemText + " " + classes.selectedItem}>
                  </ListItemText>
                </ListItem>
              </a>
            </List>
          </div>
        )
      }
      // Profile

      let e = profile.employment.slice()
      e.sort((a, b) => {
        const t1 = a.companyName
        const t2 = b.companyName
        return  t1>t2 ? 1 : t1<t2 ? -1 : 0;
      })
      const employment = e
      const activeCompany = this.activeCompany(profile)

      const companyActive = (employment && employment.length) > 1 ? (
        <List className={parentClasses.list}>
          <ListItem className={parentClasses.item}>
            <ListItemIcon className={parentClasses.itemIcon}>
              <Language/>
            </ListItemIcon>
            <ListItemText
               onClick={() => {this.setState({selector: true})}}
              disableTypography={true}
              secondary={<b className={classes.caret} />}
              primary={maxStrDisplay(activeCompany.companyName, 20)}
              className={parentClasses.itemText + " " + classes.selectedItem}>
            </ListItemText>
          </ListItem>
        </List>
      )
            :
            (<span/>)
      // set active company
      // set local storage active
      // environment set

      // Don't show empty strategy
      const companySelector = (
        (employment && employment.length > 1 && this.state.selector) ?
          (
            <List className={parentClasses.list}>
              {employment.map((e, idx) => {
                return (
                  <ListItem
                     onClick={() => {
                       window.localStorage.setItem('activeCompanyId', e.companyId)
                       this.setState({selector: false, activeCompanyId: e.companyId})
                       this.props.router.push(`/company/${e.companyId}`)
                    }}
                     key={e.companyId} className={parentClasses.item}>
                    <ListItemIcon className={parentClasses.itemIcon}>
                      <Language/>
                    </ListItemIcon>
                    <ListItemText
                       disableTypography={true}
                       primary={maxStrDisplay(e.companyName, 20) + " " + e.employeeRole}
                       className={parentClasses.itemText}>
                    </ListItemText>
                  </ListItem>
                )
              })}
            </List>

          )
        :
          <span/>
      )

      return (
        <div >
          <div>
            <div className={classes.justifyArea}>
              {this.state.selector ? companySelector : companyActive}
            </div>
            <div className={classes.clear}></div>
          </div>
        </div>
      )
    }
  }
)

export default Profile
